import { useState } from 'react';
import { SupplierDetailDrawer } from '../../supplier/supplier-detail/supplier-detail';
import { generatePath, useNavigate } from 'react-router-dom';
import { PagePath } from '@/routes/paths';
import { MsgText } from './components/msg-text';
import { InqueryDetailPortal } from './components/inqiry-portal';
import { SysWrapper } from './components/wrapper';
import { SubMsgBaseProps } from '@/features/chat-messages/types/comp-block';
import { ReplaySubMsg } from '@/features/chat-messages/types';

type ReplySystemMsgProps = Required<Pick<SubMsgBaseProps, 'sessionId' | 'dialogWrpperRef' | 'subMsg'>>;
/**
 *
 * @param param0
 * @returns
 */
export const ReplySystemMsg: React.FC<ReplySystemMsgProps> = props => {
  const { subMsg, dialogWrpperRef, sessionId } = props;
  const { contentValue } = subMsg as ReplaySubMsg;
  const [open, setOpen] = useState(false);
  const [supplierVisible, setSupplierVisible] = useState(false);
  const navigate = useNavigate();

  return (
    <SysWrapper>
      <MsgText
        contentValue={contentValue}
        actions={[
          {
            triggerFieldKeys: ['companyName'],
            handleClick: () => {
              setSupplierVisible(true);
            },
          },
          {
            triggerFieldKeys: ['contactEmail', 'contactName'],
            handleClick: () => {
              navigate(generatePath(PagePath.supplierDetail, { contactId: String(contentValue.contactId) }), {
                replace: true,
                state: { emailId: contentValue.contactEmailMsgId },
              });
            },
          },
          {
            triggerFieldKeys: ['productName', 'quantity'],
            handleClick: () => {
              setOpen(true);
            },
          },
        ]}
      />
      <SupplierDetailDrawer
        visible={supplierVisible}
        supplier={null}
        companyId={contentValue.companyId}
        isAiSummaryLoding={false}
        onClose={() => setSupplierVisible(false)}
      />
      <InqueryDetailPortal
        dialogWrpperRef={dialogWrpperRef}
        inquiryId={contentValue.inquiryTaskId}
        sessionId={sessionId}
        open={open}
        onClose={() => {
          setOpen(false);
        }}
      />
    </SysWrapper>
  );
};
